import { storageCanBeSet as pecrStorageCanBeSet } from '@JohnLewisPartnership/pecr-util';
import storageManifestJson from '../../storageManifest.json';
import constants from '../constants';

const {
  STORAGE_TYPES: { COOKIES, LOCAL_STORAGE, SESSION_STORAGE },
} = constants;

export const isLocalStorageAvailable = () => {
  let isAvailable;
  try {
    localStorage.setItem('storage', '');
    localStorage.removeItem('storage');
    isAvailable = true;
    // eslint-disable-next-line no-unused-vars
  } catch (err) {
    isAvailable = false;
  }

  return isAvailable;
};

export const isSessionStorageAvailable = () => {
  let isAvailable;
  try {
    sessionStorage.setItem('storage', '');
    sessionStorage.removeItem('storage');
    isAvailable = true;
    // eslint-disable-next-line no-unused-vars
  } catch (err) {
    isAvailable = false;
  }

  return isAvailable;
};

export function storageCanBeSet({
  storageType = '',
  storageKey = '',
  manifest = undefined,
}) {
  const storageManifest = manifest || storageManifestJson;
  const acceptedStorageTypes = [COOKIES, LOCAL_STORAGE, SESSION_STORAGE];
  const manifestUrl = '/src/storageManifest.json';
  const isTestEnv = process.env.NODE_ENV === 'test';
  if (storageType === LOCAL_STORAGE && !isLocalStorageAvailable()) {
    return false;
  }
  if (storageType === SESSION_STORAGE && !isSessionStorageAvailable()) {
    return false;
  }
  if (!storageManifest) {
    if (!isTestEnv) {
      console.group('🍪  Cookies 🍪');
      console.warn('Storage manifest file does not exist');
      console.warn(`Check ${manifestUrl} exists, if not create it`);
      console.groupEnd();
    }
    return false;
  }
  if (!acceptedStorageTypes.includes(storageType)) {
    if (!isTestEnv) {
      console.group('🍪  Cookies 🍪');
      console.warn(`Wrong storage type requested: ${storageType}`);
      console.warn(`It needs to be one of ${acceptedStorageTypes.toString()}`);
      console.groupEnd();
    }
    return false;
  }
  if (!storageManifest[storageType][storageKey]) {
    if (!isTestEnv) {
      console.group('🍪  Cookies 🍪');
      console.warn(
        `${storageType}.${storageKey} doesn't exist in the Storage Manifest: ${manifestUrl}`
      );
      console.groupEnd();
    }
    return false;
  }
  const {
    [storageType]: { [storageKey]: foundStorageKey = undefined },
  } = storageManifest;
  if (!foundStorageKey) return false;
  const canPecrStorageBeSet = pecrStorageCanBeSet(foundStorageKey);
  if (!canPecrStorageBeSet) return false;
  return true;
}

export const parseCookies = (cookieString) => {
  if (!cookieString) return {};
  return cookieString?.split(/; */)?.reduce((obj, str) => {
    if (str === '') return obj;
    const newObj = { ...obj };
    const eq = str.indexOf('=');
    const key = eq > 0 ? str.slice(0, eq) : str;
    let val = eq > 0 ? str.slice(eq + 1) : null;
    if (val != null) {
      try {
        val = decodeURIComponent(val);
        // eslint-disable-next-line no-unused-vars
      } catch (err) {
        /* pass */
      }
    }
    newObj[key] = val;

    return newObj;
  }, {});
};
